import { businessWaLink, WhatsAppIcon } from "@/lib/whatsapp";
import { useFormInView } from "@/hooks/useFormInView";

export const WhatsAppFloat = () => {
  const formInView = useFormInView();
  // Se oculta mientras el formulario está en pantalla para no tapar el botón de enviar.
  const hidden = formInView;

  return (
    <a
      href={businessWaLink()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Escríbenos por WhatsApp"
      className={`fixed z-40 right-4 bottom-24 lg:bottom-6 lg:right-6 group flex items-center gap-2 rounded-full bg-[#25D366] text-white shadow-2xl shadow-[#25D366]/40 pl-3.5 pr-4 py-3 hover:bg-[#1ebe5b] transition-[opacity,transform] duration-300 ${
        hidden ? "opacity-0 translate-y-4 pointer-events-none" : "opacity-100 translate-y-0"
      }`}
      data-testid="whatsapp-float-button"
      data-visible={!hidden}
    >
      <span className="relative flex">
        <span className="pulse-ring absolute -inset-1 rounded-full" />
        <WhatsAppIcon className="h-7 w-7 relative" />
      </span>
      <span className="font-bold text-sm hidden sm:inline">Escríbenos</span>
    </a>
  );
};
